import * as React from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

const BlogList = props => {
  const title = props.title
  const description = props.description
  const sectionClass = props.sectionClass
  const category = props.category

  const { allMdx } = useStaticQuery(graphql`
    query BlogList {
      allMdx(sort: { frontmatter: { modifyDate: DESC } }) {
        edges {
          node {
            id
            fields {
              slug
            }
            excerpt(pruneLength: 250)
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              modifyDate(formatString: "MMMM DD, YYYY")
              title
              categories
              featured {
                childImageSharp {
                  gatsbyImageData(width: 416)
                }
              }
            }
          }
        }
      }
    }
  `)

  const posts = allMdx.edges

  // console.log(posts)

  return (
    <>
      <section className={`blog-list-section section ${sectionClass}`}>
        <Container className='py-5'>
          <div className='w-75'>
            <div className='section-title mb-5 pb-1'>
              <h2 className='heading mb-4' dangerouslySetInnerHTML={{ __html: title }} />
              <p>{description}</p>
            </div>
          </div>
          <Row xs={1} lg={3} className='g-4'>
            {category
              ? posts
                .filter(edge =>
                  edge.node.frontmatter.categories?.some(i =>
                    category.includes(i)
                  )
                )
                .map(
                  (post, index) =>
                    index < 3 && (
                      <Col key={index}>
                        <Link
                          to={post.node.fields.slug}
                          className='blog-list-card single'
                        >
                          <div className='blog-image'>
                            <GatsbyImage
                              loading='lazy'
                              width={416}
                              height={250}
                              image={
                                post.node.frontmatter?.featured
                                  ?.childImageSharp.gatsbyImageData
                              }
                              alt='featured'
                            />
                          </div>
                          <div className='blog-list-content mt-4'>
                            <h2 className='blog-title fw-normal h4'>
                              {post.node.frontmatter.title}
                            </h2>
                          </div>
                        </Link>
                      </Col>
                    )
                )
              : posts.map(
                (post, index) =>
                  index < 3 && (
                    <Col key={index}>
                      <Link
                        to={post.node.fields.slug}
                        className='blog-list-card single'
                      >
                        <div className='blog-image'>
                          <GatsbyImage
                            loading='lazy'
                            width={416}
                            height={250}
                            image={
                              post.node.frontmatter?.featured?.childImageSharp
                                .gatsbyImageData
                            }
                            alt='featured'
                          />
                        </div>
                        <div className='blog-list-content mt-4'>
                          <h2 className='blog-title fw-normal h4'>
                            {post.node.frontmatter.title}
                          </h2>
                        </div>
                      </Link>
                    </Col>
                  )
              )}
          </Row>
          <div className='mt-4 text-center'>
            <Link to='/blog' className='btn btn-link mt-4'>
              <span>view more blogs</span>{' '}
              <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
            </Link>
          </div>
        </Container>
      </section>
    </>
  )
}

BlogList.defaultProps = {
  title: 'Featured <span class="text-primary fw-bold">blogs</span>',
  description: 'Scan ‘N’ Thru aspires to make checkouts hassle-free. We love what we do and we love discussing and sharing our insightful thoughts through our blogs. Stay informed with our in-depth blogs, where we share knowledge on cutting-edge solutions shaping the future of retail.',
  sectionClass: 'bg-light'
}

export default BlogList
